import instance from "@/services/api";

export const getMenu = async () => {
  return await instance().get('/common/menu/read/').then(res => res?.data);
};

export const getMenuStatuses = async () => {
  return await instance()
    .get("/common/menu/statuses/")
    .then((res) => res?.data);
};